import NRCS from "../../../images/stackable-practice-nrcs.png"
import SPB from "../../../images/stackable-practice-spb.png"

export const SAVED_STACKS = {
  govt_application: {
    title: "NRCS Stackable Practice 1",
    image: NRCS,
  },
  spb: {
    title: "Southern Pine Beetle Stackable Practice",
    image: SPB,
  },
}
